module.exports = __webpack_public_path__ + "2b13482f49af1c8b3944537fc3a5c943.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-pink-s.png
// module id = 2198
// module chunks = 0